require('./brokerGeoZoneBreakdownTable.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

const { formatText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');

// @commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

class BrokerGeoZoneBreakdownTable extends React.Component {

    constructor(props) {
        super(props);
        this.rows = this.rows.bind(this);
        this.handleRowHover = this.handleRowHover.bind(this);
    }

    handleRowHover(ev) {
        this.props.handleActiveRegionChange(parseInt(ev.target.id.split('__')[1]), 10);
    }

    headers() {
        return (
            <OKTableRow asHeader={true}>
                <OKTableCell
                    asHeader={true}
                    className="broker-geozone-breakdown-table__header-cell"
                >
                    {formatText('broker-geoZoneBreakdownTableRegionLabel')}
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="broker-geozone-breakdown-table__header-cell"
                >
                    {formatText('broker-geoZoneBreakdownTableFundLabel')}

                </OKTableCell>
            </OKTableRow>
        );
    }

    rows() {
        const filtered = this.props.tableData.filter(item => item.get('Value'));

        return filtered.map(item => (
            <tr
                key={item.get('Type')}
                onMouseOver={this.handleRowHover}
                className={
                    parseInt(item.get('Type'), 10) === this.props.activeRegion ?
                        "ok-table-row broker-geozone-breakdown-table__row--active" :
                        "ok-table-row"
                }
            >
                <OKTableCell id={`left-cell__${item.get('Type')}`}>
                    {formatText(`broker-geoZoneBreakdownRegion${item.get('Type')}`)}
                </OKTableCell>
                <OKTableCell id={`right-cell__${item.get('Type')}`}>
                    {formatAmount(item.get('Value')) !== '' ? formatAmount(item.get('Value')) + '%' : '-'}
                </OKTableCell>
            </tr>
        ));
    }

    render() {
        return (
            <OKTable className="broker-geozone-breakdown-table">
                <thead>
                    {this.headers()}
                </thead>
                <tbody>
                    {this.rows()}
                </tbody>
            </OKTable>
        );
    }
}

BrokerGeoZoneBreakdownTable.propTypes = {
    tableData: PropTypes.object.isRequired,
    handleActiveRegionChange: PropTypes.func.isRequired,
    activeRegion: PropTypes.number.isRequired
};

module.exports = BrokerGeoZoneBreakdownTable;
